/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import moment from 'moment'
import React, { useState } from 'react'
import TableHead from './TableHead'

export default function Invoice({
    state,
    setState,
    oldState,
    setToastErrorMessage,
    errorIndex, 
    setErrorIndex,
    setAppliedError,
    mainReceivedAmount
}) {    
    const [isClickSelect, setIsClickSelect] = useState(false);

    /**
     * The function `handleInvoiceSelectedCheckbox` is used to handle the selection of an invoice
     * checkbox and update the state accordingly.
     */
    const handleInvoiceSelectedCheckbox = (index) => {
        setAppliedError(false)
        setToastErrorMessage("")
        setIsClickSelect(!isClickSelect)
        let AppliedAmount = 0;
        if (!state.invoices[index].is_selected) {
            let dueAmount = 0;
            let receivedAmount = 0;
            let entered_amount = state.received_amount
            for (let index = 0; index < state.invoices?.length; index++) {
                for (let index2 = 0; index2 < state.invoices[index].items?.length; index2++) {
                    entered_amount -= state.invoices[index].items[index2].received_line_amount || 0
                }   
            }
            const updatedInvoices = state.invoices.map((invoice, idx = 0) => {
                return {
                    ...invoice,
                    items: invoice.items.map((item, item_index = 0) => {
                        if (entered_amount > 0 && item.balance_line_amount > 0 && idx === index) {
                            const amountToApply = Math.min(entered_amount, item.balance_line_amount);
                            entered_amount -= amountToApply;
                            dueAmount += parseFloat((item.balance_line_amount - amountToApply)) ;
                            receivedAmount +=  parseFloat(amountToApply);
                            AppliedAmount += parseFloat(receivedAmount);
                            return {
                                ...item,
                                received_line_amount: parseFloat(amountToApply),
                                balance_line_amount: parseFloat((item.balance_line_amount - amountToApply)),
                            };
                        }
                        if (idx === index) {
                            dueAmount += item.balance_line_amount ;
                            receivedAmount +=  item.received_line_amount;
                        }
                        AppliedAmount += parseFloat((item?.received_line_amount || 0));
                        return item;
                    }),
                };
            });
    
            updatedInvoices[index].due_amount = parseFloat(dueAmount);
            updatedInvoices[index].received_amount = parseFloat(receivedAmount);
    
            setState((prevState) => ({
                ...prevState,
                invoices: updatedInvoices,
                applied_amount: parseFloat(AppliedAmount),
                remaining_amount: parseFloat(state.received_amount)> 0? parseFloat((state.received_amount - AppliedAmount)) : 0,
            }));
        } else {
            const updatedInvoices = state.invoices.map((invoice, idx = 0) => {
                if (idx === index) {
                    // AppliedAmount = AppliedAmount - parseFloat(state?.invoices[idx].received_amount.toFixed(2));
                }
                return {
                    ...invoice,
                    due_amount: idx === index ? parseFloat(oldState?.invoices[idx].due_amount) : state?.invoices[idx].due_amount,
                    items: invoice.items.map((item, item_index = 0) => ({
                        ...item,
                        received_line_amount: idx === index ? 0 : parseFloat(state?.invoices[idx].items[item_index].received_line_amount),
                        balance_line_amount: idx === index ? parseFloat(oldState?.invoices[idx].items[item_index].balance_line_amount) : state?.invoices[idx].items[item_index].balance_line_amount,
                    })),
                };
            });
    
            setState((prevState) => ({
                ...prevState,
                invoices: updatedInvoices,
                applied_amount: parseFloat(AppliedAmount),
                remaining_amount: parseFloat((state.received_amount - AppliedAmount)),
            }));
        }
    
        setState((prevState) => ({
            ...prevState,
            invoices: prevState.invoices.map((invoice, i) => ({
                ...invoice,
                is_selected: i === index ? !invoice.is_selected : invoice.is_selected,
            })),
        }));
    };
    
    return (
        <> 
            <div className='mb-4 z-10 w-[100%] mx-auto'>
                <div className=''>
                    {state?.invoices.map((invoice, index = 0 ) => (
                        <div className="border border-[#c2dcef] mb-[25px]" key={index+"invoices"}>
                            <div className='bg-[#EEF7FE] py-[10px] pr-[21px] pl-[13px]' style={{'border-bottom':'1px solid #c2dcef'}}>
                                <div className='flex justify-between'>
                                    <div class="relative checkbox custom-checkBoxBlueBranch1" title='Click to Apply Payment'>
                                        <input 
                                            type="checkbox" 
                                            id={index+"invoices"} 
                                            data-testid={`text-box`+index}  
                                            name={index+"invoices"} 
                                            checked={invoice.is_selected} 
                                            onChange={() => handleInvoiceSelectedCheckbox(index)}
                                        />
                                        <label 
                                            htmlFor={index+"invoices"}
                                            class="text-f2 font-semibold text-[#031624] pl-2.5 w-full cursor-pointer"
                                        >
                                            {invoice?.invoice_number}
                                        </label>
                                    </div>
                                    <div>
                                        <p className='font-semibold text-f7'>
                                            {invoice?.invoice_name}
                                        </p>
                                    </div>
                                    <div className='flex'>
                                        <p className='pr-2 font-normal text-f7'>
                                            Amount
                                        </p>
                                        <p className='font-semibold text-f7'>
                                            {invoice?.invoice_total?.toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                                <div className='flex justify-between mt-1'>
                                    <p className='font-normal text-f7 ml-5'>
                                        {moment.utc(invoice?.date).format('MMM DD, YYYY')}
                                    </p>
                                    <div className='flex'>
                                        <p className='pr-2 font-normal text-f7'>
                                            Due
                                        </p>
                                        <p className='font-semibold text-f7'>
                                            {oldState.invoices[index]?.due_amount?.toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {invoice.is_selected && <TableHead 
                                tableData={invoice.items} 
                                tableIndex={index} 
                                state={state} 
                                setState={setState}
                                invoice={invoice}
                                setToastErrorMessage={setToastErrorMessage}
                                oldState={oldState}
                                errorIndex={errorIndex}
                                setErrorIndex={setErrorIndex}
                                setAppliedError={setAppliedError}
                                mainReceivedAmount={mainReceivedAmount}
                                isClickSelect={isClickSelect}
                            />}
                        </div>))}
                </div>
            </div>
        </>
       
    )
}
